module.exports = __webpack_public_path__ + "bv.svg?89490dfe6089d40803e9b48427ccc82d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bv.svg
// module id = 767
// module chunks = 27